import React from 'react';

const EthicalStatement = () => {
  return (
    <section className="bg-white pt-20 pb-12 px-2">
      <div 
        className="mx-auto text-center uppercase font-medium transition-colors duration-200 ease-in-out
                   text-[10px] md:text-[13px] 
                   leading-[23.4px] tracking-[3px] -mt-[4.225px]"
        style={{
          maxWidth: '830.4px',
          fontFamily: 'Montserrat, sans-serif',
          color: 'rgb(5, 41, 5)',
          WebkitFontSmoothing: 'antialiased'
        }}
      >
        WE BELIEVE ETHICAL JEWELRY IS A STYLE LOVER'S BEST FRIEND. CRAFTED WITH CARE,
        TRANSPARENCY AND SUSTAINABLY SOURCED MATERIALS, OUR TIMELESS YET MODERN PIECES
        ARE DESIGNED TO BE WORN EVERY DAY AND CHERISHED FOR A LIFETIME.
      </div>
    </section>
  );
};

export default EthicalStatement;
